export enum ViewType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
